// ModalContext.tsx
import React, { createContext, useContext } from "react";
import { Modal } from "antd";

type ModalStaticFunctions = Omit<
  ReturnType<typeof Modal.useModal>[0],
  "destroyAll"
>;

interface ModalContextProps {
  modal: ModalStaticFunctions;
}

const ModalContext = createContext<ModalContextProps | null>(null);

export const useGlobalModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useGlobalModal must be used within ModalProvider");
  }
  return context.modal;
};

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [modal, contextHolder] = Modal.useModal();

  return (
    <ModalContext.Provider value={{ modal }}>
      {contextHolder}
      {children}
    </ModalContext.Provider>
  );
};
